import { render, staticRenderFns } from "./TeamCardList.vue?vue&type=template&id=15fb16a4&scoped=true"
import script from "./TeamCardList.vue?vue&type=script&lang=js"
export * from "./TeamCardList.vue?vue&type=script&lang=js"
import style0 from "./TeamCardList.vue?vue&type=style&index=0&id=15fb16a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fb16a4",
  null
  
)

export default component.exports